import React from 'react';

import './LoginPageSkeleton.scss';

export default function LoginPageSkeleton() {
  return (
    <div className='LoginPageSkeletonWrapper'>
      {/* LEFT SIDE: Banner Skeleton */}
      <div className="skeletonBannerSection">
        <div className="skeletonBannerContent">
          <div className="skeletonBannerTitle skeleton-shimmer"></div>
          <div className="skeletonBannerSubtitle skeleton-shimmer"></div>
          <div className="skeletonBannerSubtitle skeletonBannerSubtitleShort skeleton-shimmer"></div>
        </div>
      </div>

      {/* RIGHT SIDE: Form Skeleton */}
      <div className="skeletonFormSection">
        <div className="skeletonFormWrapper">
          <div className="skeletonFormContainer">
            {/* Header */}
            <div className="skeletonHeader">
              <div className="skeletonTitle skeleton-shimmer"></div>
              <div className="skeletonSubtitle skeleton-shimmer"></div>
            </div>

            {/* Form Fields */}
            <div className="skeletonContent">
              <div className="skeletonForm">
                {/* Phone Field */}
                <div className="skeletonField">
                  <div className="skeletonInput skeleton-shimmer"></div>
                </div>

                {/* Email Field */}
                <div className="skeletonField">
                  <div className="skeletonInput skeleton-shimmer"></div>
                </div>

                {/* OTP Field */}
                <div className="skeletonField">
                  <div className="skeletonInput skeleton-shimmer"></div>
                </div>

                {/* Terms and Conditions */}
                <div className="skeletonTerms">
                  <div className="skeletonTermsLine skeleton-shimmer"></div>
                  <div className="skeletonTermsLine skeletonTermsLineShort skeleton-shimmer"></div>
                </div>

                {/* Submit Button */}
                <div className="skeletonButton skeleton-shimmer"></div>
              </div>
            </div>

            {/* Footer */}
            <div className="skeletonFooter">
              <div className="skeletonFooterText skeleton-shimmer"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
